<template>
  <el-table-column
    prop="is_product_billable"
    label="Termék számlázandó"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.is_product_billable ? 'Igen' : 'Nem' }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'is_product_billable',
  };
</script>
